import { gql } from '@apollo/client'

import { ORDER_FRAGMENT } from '../../fragments'

export const GET_CURRENT_CUSTOMER_ORDERS = gql`
  query CurrentCustomerOrders {
    currentCustomer {
      id
      orders {
        ...OrderFields
      }
    }
  }
  ${ORDER_FRAGMENT}
`
